/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {FabUser} from '@fabric/common/types';
import {throwError as observableThrowError, Observable, of, BehaviorSubject} from 'rxjs';

import {map} from 'rxjs/operators';
import {inject, Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {APP_CONFIG} from '../app.config';
import {UserInfo} from "../model/user-info";

@Injectable()
export class UserAuthService {
  private _userInfoUrl;
  private _user: UserInfo
  private _fabUser: BehaviorSubject<FabUser> = new BehaviorSubject(null);
  private _isSuperAdmin: boolean = false;
  private _isSiteAdmin: boolean = false;

  constructor(private http: HttpClient) {
    this._userInfoUrl = inject(APP_CONFIG).baseUrl + '/api/userinfo';
  }

  getUserAuth(): Observable<UserInfo> {
    return this.http.get(this._userInfoUrl).pipe(
      map(response => {
        this._user = response as UserInfo;
        return this._user;
      }, error => {
        observableThrowError(error);
      }));
  }



  isSuperAdmin(): boolean{
    return this._user.roles.indexOf("PGA_Admin") >= 0;
  }

  isSiteAdmin(): boolean{
    return this._user.roles.indexOf("PGA_SiteAdmin") >= 0;
  }

  getUser(): Observable<FabUser> {
    return this._fabUser.asObservable();
  }

  setUser(user: FabUser) {
    this._fabUser.next(user);
  }
}
